module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-startbnc",
    class: [_vm.closing ? 'kiwi-startbnc--closing' : '']
  }, [_c('div', {
    staticClass: "kiwi-startbnc-section kiwi-startbnc-section-connection"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.greetingText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-startbnc-status"
  }, [_vm._v(_vm._s(_vm.statusMessage))]), _vm._v(" "), _c('form', {
    staticClass: "kiwi-startbnc-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.startUp($event)
      }
    }
  }, [_c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('username')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "u-button u-button-primary u-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.loading || !_vm.username || !_vm.password
    }
  }, [(!_vm.loading) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.buttonText)
    }
  }) : _c('i', {
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-startbnc-section kiwi-startbnc-section-info",
    style: (_vm.infoStyle)
  }, [(_vm.infoContent) ? _c('div', {
    staticClass: "kiwi-startbnc-section-info-content",
    domProps: {
      "innerHTML": _vm._s(_vm.infoContent)
    }
  }, [_c('h3', [_vm._v("Take your conversations anywhere.")]), _vm._v(" "), _c('h4', [_vm._v("IRC? No problem.")]), _vm._v(" "), _c('p', [_vm._v("IRC has a history of being difficult, lets makes it usable.")]), _vm._v(" "), _c('p', [_vm._v("Just log in and get going.")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e27f74e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/startups/KiwiBnc.vue
// module id = 476
// module chunks = 2